"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const http_1 = require("@angular/common/http");
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const core_2 = require("@ngx-translate/core");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const BaseComponent_1 = require("../../../commons/BaseComponent");
const map_service_1 = require("../../../commons/map.service");
const annotation_report_1 = require("../annotation-report");
const map_component_1 = require("../map.component");
// import * as cloneDeep from 'lodash/cloneDeep';
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
const acl_service_1 = require("../../../commons/acl/acl.service");
const Constants_1 = require("../../../commons/Constants");
const global_1 = require("../../../commons/global");
const entity_helper_service_1 = require("../../../service/entity-helper.service");
const measurement_helper_service_1 = require("../../../service/measurement-helper.service");
const plugin_manager_service_1 = require("../../../service/plugin-manager.service");
const application_events_service_1 = require("../../../xs/services/events/application-events.service");
const Cesium = window.Cesium;
/*
 * Time for some documentation. The inspection component functions as a controller for all Annotations;

    - the list of Annotations for *the whole project*
    - the search/filter/sort of said list (and one filter is to filter it to current scene, for example)
    - it's responsible for drawing all Annotations to the screen;
      * Pins through cesiumHelper.addPlottable()
      * Other (lines, polygons) through measurementHelper (at the moment)
      * Artefacts (points/handles and ghostlines) for editing said shapes

  Keep in mind that every Annotation apart from Pins (for now) is effectively a group of shapes. So, for
  example, a Line is really a group of lines that most often only has one line in it. Over time a lot of
  the annotations will have native SDK support, but for now it's all handled by this component.


*/
class InspectionComponent extends BaseComponent_1.BaseComponent {
    constructor(route, router, snackBar, dialog, httpClient, fourD, permissions, uiManager, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, pluginManager, t, measureHelper) {
        super(router, snackBar, dialog);
        this.route = route;
        this.router = router;
        this.snackBar = snackBar;
        this.httpClient = httpClient;
        this.fourD = fourD;
        this.permissions = permissions;
        this.uiManager = uiManager;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.mappingHelper = mappingHelper;
        this.entityHelper = entityHelper;
        this.pluginManager = pluginManager;
        this.t = t;
        this.measureHelper = measureHelper;
        this.debug = Constants_1.Constants.debug_off;
        this.searchCont = new forms_1.FormControl();
        // This corresponds to the "Filter by scene" toggle.
        this.globalScope = true;
        // currentType really is the currently selected/active tool. This is the one we're aiming to replace
        this.currentType = 'poi';
        this.annots = [];
        this.originalAnnots = null;
        this.selected = null;
        // DOM selector object for the HTML selector
        this.html_selector = null;
        // what are we allowed to do?
        // allowed: Object = null;
        // dynamic list of tools
        this.listOfTools = null; //  this is the old one; remove it once the new is in place
        // tools: any = null;
        // currently selected tool (and a click on the map will create a new one)
        this.selectedTool = false;
        this.editingShape = false;
        // tracks and manages the mode of the user interface (tabs, buttons, what to turn on and off, etc.)
        this.gui = [];
        // the cursor for creating a new annotation
        this.mouseCursor = null;
        this.mouseCursorCoords = null;
        // mouse handler for mouse movements (used for showing initial cursor)
        this.mouseHandler = null;
        const debugStyle = 'color:white;background-color:black;';
        // listen out for annotation changes (usually means the list of all annotations have changed, loaded, deleted, etc.)
        this.addSubscription('onAnnotationsChange', this.mapService.onAnnotationsChange().subscribe((annotationArray) => {
            // just keep a handy copy of the incoming original annotations
            if (!this.originalAnnots) {
                this.originalAnnots = annotationArray;
            }
            // initialise / setup each annotation
            annotationArray.forEach((a) => {
                // if format is is only in the old format, convert it to the new format
                if (!a['shapes'] && a['points']) {
                    a['shapes'] = this.mappingHelper.convertFromOldFormat(a);
                }
                else {
                    // if there's shapes (is an array), let's check the formatting being valid
                    if (a['shapes'] instanceof Array && !this.mappingHelper.testFormat(a['shapes'])) {
                        a['shapes'] = this.mappingHelper.convertFromOldFormat(a);
                    }
                    else {
                    }
                }
            });
            if (this.debug) {
                console.log('%c inspect.component :: subscribed : onAnnotationsChange() -> renderAllAnnotations()', debugStyle, annotationArray);
            }
            // OK, draw all primitive entities on the map
            this.renderAllAnnotations(annotationArray);
        }));
        // listen out for annotation single annotation changing (due to details being saved)
        this.addSubscription('onSingleAnnotationChange', this.mapService.onSingleAnnotationChange().subscribe((annotation) => {
            // this.renderAllAnnotations([annotation]);
            // Refactor; temporary disabled
            /*
            if(annotation['annotationMode'] === 'poi'){
    
              // if ( this.debug ) { console.log ( 'inspect.component :: subscribed : onSingleAnnotationChange() -> remove/addPlottable()'); }
              this.mapService.helper.removePlottable(annotation)
              this.mapService.helper.addPlottable(annotation).subscribe(res => {
                if ( this.debug ) { console.log ( 'inspect.component :: subscribed : onSingleAnnotationChange() -> remove/addPlottable() -> billboard update'); }
                res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable)
              })
    
            }else if(annotation['showPermanent']){ // if show permanent then show it
    
              if ( this.debug ) { console.log ( 'inspect.component :: subscribed : onSingleAnnotationChange() -> renderAllAnnotations()', annotation.id ); }
              this.renderAllAnnotations([annotation]);
    
              // this.mappingHelper.showPermanentPoints(annotation,true);
            }
            */
        }));
        // if page refresh then set currentType from the url request annotation
        this.addSubscription('newAnnotationReady', this.mapService.newAnnotationReady.subscribe((_) => {
            this.currentType = this.mapService.newAnnotation['annotationMode'];
        }));
        // listen to search textbox
        this.searchCont.valueChanges.pipe(operators_1.debounceTime(1000)).subscribe((v) => {
            this.loading = true;
            if (v == '' || !v) {
                this.mapService.searchAnnots().subscribe((_) => (this.loading = false));
            }
            else {
                let c = {
                    op: 'and',
                    items: [
                        {
                            col: 'name',
                            op: 'like',
                            val: '~' + v + '~',
                        },
                    ],
                };
                this.mapService.searchAnnots(c).subscribe((_) => (this.loading = false));
            }
        });
        // update dataset name and type
        this.addSubscription('sock', this.mapService.v2Maps.annotations.events.subscribe((s) => {
            if (s.event == 'ADD')
                this.annotAdjust(s.item, 'add');
            else if (s.event == 'REMOVE')
                this.annotAdjust(s, 'del');
            else
                this.annotAdjust(s, 'update');
        }));
        // access control changes
        this.addSubscription('permissionsUpdated', this.permissions.updatedAccess$.subscribe((tmp) => {
            this.changeAccess();
        }));
        this.addSubscription('onCesiumReady', this.mapService.onCesiumReady().subscribe((_) => {
            // our own mouse handler to trap early clicks (to make sure we don't click on the possibly active cursor)
            this.mouseHandler = new Cesium.ScreenSpaceEventHandler(this.mapService.viewer.scene.canvas);
            // set up left-down-click handler
            this.mouseHandler.setInputAction((movement) => {
                this.onLeftDownClick(movement);
            }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
        }));
    }
    init() {
        if (this.debug) {
            console.log('inspect.comp :: init()');
        }
        var lastScene = null;
        this.addSubscription('onSceneChange', this.mapService.onSceneChange('inspect.component').subscribe((scene) => {
            if (scene != lastScene) {
                this.filterAnnotationsByScene();
                lastScene = scene;
            }
        }));
    }
    toggleShapeEditor() {
        this.editingShape = !this.editingShape;
    }
    renderAllAnnotations(incoming) {
        //this.debug = true;
        if (this.debug) {
            console.log('%c inspect.comp %c renderAllAnnotations() annots,incoming ', Constants_1.Constants._pink, Constants_1.Constants._pink, this.annots, incoming);
        }
        // if ( this.debug ) { console.log ( '%c inspect.comp %c renderAllAnnotations() find 0 ', Constants._pink, Constants._purple, this.annots.find(aa => aa.id == 0) ); }
        var toAdd = incoming.filter((annotation) => !this.annots.find((aa) => aa.id == annotation.id));
        var toDel = this.annots.filter((annotation) => !incoming.find((aa) => aa.id == annotation.id));
        // console.log ( '%c inspect.comp %c renderAllAnnotations() del,add ', Constants._pink, Constants._red, toDel, toAdd );
        // remove old annots
        toDel.forEach((annotation) => {
            // delete all shapes for this annotation
            this.mappingHelper.deleteAnnotationShapes(annotation);
        });
        // add new ones
        rxjs_1.forkJoin(toAdd.map((annotation, index) => {
            // create our shapes
            let a = this.mappingHelper.createAnnotationShapes(annotation);
            if (this.debug) {
                console.log('%c inspect.comp :: renderAllAnnotations() forkJoin TO_ADD', Constants_1.Constants._pink, annotation, a);
            }
            // depending on it's saved state, show or hide it
            this.entityHelper.showHideEntity(annotation, annotation['showPermanent']);
            // return the shape reference
            return a;
        })).subscribe((returned) => {
            if (this.debug) {
                console.log('%c inspect.comp :: renderAllAnnotations()', Constants_1.Constants._pink, returned);
            }
            // what's returned? (only goes through Pins)
            returned.forEach((res) => {
                if (res && res.object.pin) {
                    let pin = res.object.pin;
                    pin['type'] = 'poi';
                    pin['__type'] = 'poi';
                    pin['__def'] = 'i.c:pin';
                    pin.billboard.verticalOrigin = Cesium.VerticalOrigin.BOTTOM;
                    pin.billboard.horizontalOrigin = Cesium.HorizontalOrigin.CENTER;
                    if (this.debug) {
                        console.log('%c inspect.comp :: renderAllAnnotations() -> get pin', Constants_1.Constants._pink, res);
                    }
                    pin.billboard.image = this.entityHelper.getPinImage(res.plottable, this.selected && this.selected.id == res.plottable.id ? 'yellow' : null);
                }
            });
            //this.debug = false;
        });
        // transfer incoming to our current state
        this.annots = incoming;
    }
    clickedMap(movement, rightClick, checkedPosition) {
        this.debug = true;
        if (this.debug) {
            console.log('inspect.comp :: clickedMap() -- START', this.selectedTool, checkedPosition);
        }
        // a tool is selected, so this is a new annotation then
        if (this.selectedTool) {
            // nullify selections
            this.setSelected(null, true, 'inspect:clickedMap()');
            if (this.debug) {
                console.log('inspect.comp :: clickedMap() -- NEW ANNOTATION', checkedPosition);
            }
            // create the annotation, and go there!
            this.createNewAnnotation(this.selectedTool.id, checkedPosition);
            // unselect the tool, and remove the cursor
            this.unselectTool();
        }
        // clicked a handle (shoudln't happen from the inspection component, but you'll never know)
        else if (checkedPosition.handle) {
            if (this.debug) {
                console.log('inspect.comp :: clickedMap() -- HANDLE', checkedPosition.handle.id, checkedPosition);
            }
            // clicked a feature (pin, line, area, etc.)
        }
        else if (checkedPosition.feature) {
            let ref = checkedPosition.feature.fourd_ref || (checkedPosition['props'] && checkedPosition.props.annotationRef);
            if (this.debug) {
                console.log('inspect.comp :: clickedMap() -- FEATURE', checkedPosition.feature.id, ref, checkedPosition);
            }
            let newSelect = this.mapService.annotations.find((annotation) => annotation.id == ref);
            if (newSelect) {
                if (!checkedPosition.feature.fourd_ref) {
                    newSelect[0]['entityRef'] = checkedPosition.feature.id;
                    newSelect[0]['shapeRef'] = checkedPosition.props.shapeRef;
                }
                this.setSelected(newSelect, true, 'inspect:clickedMap() NEW_SELECT');
            }
        }
        // clicked elsewhere on the map
        else {
            // nullify selections
            this.setSelected(null, true, 'inspect:clickedMap() ELSE');
            // unselect the tool, and remove the cursor
            this.unselectTool();
            if (this.debug) {
                console.log('inspect.comp :: clickedMap() -- NOTHING', checkedPosition);
            }
        }
        if (this.debug) {
            console.log('inspect.comp :: clickedMap() -- END', checkedPosition);
        }
        this.debug = false;
        return rightClick ? map_component_1.ClickDisplay.None : map_component_1.ClickDisplay.Chevron;
        // refactor; turn off for now
        /*
        var feature = this.mapService.viewer.scene.pick(movement.position);
        var def = Cesium.defined(feature);
        if ( this.debug ) { console.log ( 'inspect.comp :: clickedMap', movement, 'rightClick', rightClick, 'feature', feature, 'def', def );}
    
        if (def && !feature.content && feature.id.fourd_ref) {
          var newSelect = this.mapService.annotations.find(annotation => annotation.id == feature.id.fourd_ref)
          this.setSelected(newSelect)
          if ( this.debug ) { console.log ( 'inspect.comp :: clickedMap -> found/set feature', newSelect );}
    
        } else {
    
    
    
          // if details tab is open....
          if(this.mapComp.detailsNav.opened){
            this.setSelected(null);
            if ( this.debug ) { console.log ( 'inspect.comp :: clickedMap -> details tab open' );}
            return ClickDisplay.Chevron;
          }
    
          else if(!rightClick) {
            if(this.mapComp.currentCoord){ // if local coordinates then currentcoord may be null if clicked outside of the model.
              if ( this.debug ) { console.log ( 'inspect.comp :: clickedMap -> make annotation at coord' );}
              this.createNewAnnotation(this.currentType,this.mapComp.currentCoord.position)
            }
          }
    
          else {
            // clicking annotation blank area, show the balloon
            if ( this.debug ) { console.log ( 'inspect.comp :: clickedMap -> nothing (show menu?)' );}
            return rightClick?ClickDisplay.None:ClickDisplay.Chevron
          }
        } */
    }
    setSelected(annotation, navgate = true, from = 'dunno') {
        this.annotationShowPermanentTemp = false;
        if (this.debug) {
            console.log('inspect.comp :: setSelected()', annotation, navgate, from);
        }
        // this is a roundabout way of not selecting any Annotation until the Cesium helper is ready
        if (this.mapService.helper) {
            this.processSelectedAnnotation(annotation, navgate);
        }
        else {
            this.addSubscription('onCesiumReady', this.mapService.onCesiumReady().subscribe((_) => {
                this.processSelectedAnnotation(annotation, navgate);
            }));
        }
    }
    processSelectedAnnotation(a, navgate) {
        // delselect old one
        if (this.selected) {
            var p = this.mapService.helper.getCesiumObjectFor(this.selected);
            if (p && p.pin && p.pin.billboard) {
                p.pin.billboard.image = this.entityHelper.getPinImage(this.selected);
            }
            if (this.debug) {
                console.log('inspect.component :: processSelectedAnnotation() [on existing selected; turn billboard to old]', a, p, navgate);
            }
        }
        this.selected = a;
        // is there an Annotation?
        if (a) {
            // select new one
            var p = this.mapService.helper.getCesiumObjectFor(this.selected);
            if (p && p.pin && p.pin.billboard) {
                p.pin.billboard.image = this.entityHelper.getPinImage(this.selected, 'yellow');
            }
            if (this.debug) {
                console.log('inspect.component :: processSelectedAnnotation()', a, p, navgate);
            }
            if (!a['showPermanent']) {
                this.showHideAnnotation(a, { currentTarget: { checked: true } });
                this.annotationShowPermanentTemp = true;
            }
            if (navgate && this.mapService.currentProject) {
                this.router.navigate([
                    this.fourD.activeUser ? '/app/projects/map' : '/map',
                    this.mapService.currentProject.id,
                    a['annotationMode'] == 'PIN' ? 'poi' : a['annotationMode'] || 'poi',
                    a.id,
                ]);
            }
        }
        // No Annotation
        else {
            if (this.debug) {
                console.log('inspect.component :: processSelectedAnnotation() [no Annotation]', a, navgate);
            }
            if (navgate) {
                this.router.navigate([this.fourD.activeUser ? '/app/projects/map' : '/map', this.mapService.currentProject.id, 'annot']);
            }
        }
    }
    becameActive(mapComp) {
        this.mapComp = mapComp;
    }
    becameInactive(mapComp) { }
    changeAccess() {
        let allowed = this.permissions.can;
        if (allowed && allowed['see']) {
            this.mapComp.state_engine.addFeature('poi', {
                allowed: allowed['see']['pin'],
                icon: 'map-marker',
                showOptionIn: 'tools_menu',
                showContentIn: 'details',
            });
            this.mapComp.state_engine.addFeature('line', {
                allowed: allowed['see']['line'],
                icon: 'slash',
                showOptionIn: 'tools_menu',
                showContentIn: 'details',
            });
            this.mapComp.state_engine.addFeature('area', {
                allowed: allowed['see']['area'],
                icon: 'draw-polygon',
                showOptionIn: 'tools_menu',
                showContentIn: 'details',
            });
            this.mapComp.state_engine.addFeature('volume', {
                allowed: allowed['see']['volume'],
                icon: 'cube',
                showOptionIn: 'tools_menu',
                showContentIn: 'details',
            });
            this.mapComp.state_engine.addFeature('multiPoi', {
                allowed: allowed['see']['points'],
                icon: 'dot-circle',
                showOptionIn: 'tools_menu',
                showContentIn: 'details',
            });
            this.gui.tools = this.mapComp.state_engine.getWidget('tools_menu');
            // when we're ready, enable this line (@alex)
            // this.listOfTools = this.mapComp.state_engine.getWidget('tools_menu');
        }
    }
    onChangeSaveAnnotation(cur) {
        if (this.debug) {
            console.log('inspect.component :: onChangeSaveAnnotation()', cur);
        }
        if (this.mapService.newAnnotation) {
            this.currentType = this.mapService.newAnnotation['annotationMode'];
            this.openSnackBarWarn('MAP.MEASUREMENT_MSG');
        }
        else {
            this.currentType = cur;
            if (cur == 'terrain-compare') {
                this.router.navigate(['terrainCompare', -1], { relativeTo: this.route });
                this.mapService.inTerrainCompare = true;
            }
            else if (cur === 'photogram') {
                this.router.navigate(['photogram'], { relativeTo: this.route });
            }
        }
    }
    onClickSaveAnnotation(cur) {
        if (this.debug) {
            console.log('inspect.component :: onClickSaveAnnotation()');
        }
        if (cur == 'terrain-compare' && !this.mapService.newAnnotation && !this.mapService.inTerrainCompare) {
            this.router.navigate(['terrainCompare', -1], { relativeTo: this.route });
            this.currentType = cur;
            this.mapService.inTerrainCompare = true;
        }
        else if (cur === 'photogram') {
            this.router.navigate(['photogram'], { relativeTo: this.route });
        }
    }
    getStandardIcon(a) {
        let type = a['annotationMode'];
        switch (type) {
            case global_1.AnnotationType.poi:
                return a['icon'] ? a['icon'] : 'map-marker-alt';
            case global_1.AnnotationType.multipoi:
                return 'dot-circle';
            case global_1.AnnotationType.line:
                return 'horizontal-rule';
            case global_1.AnnotationType.area:
                return 'draw-polygon';
            case global_1.AnnotationType.volume:
                return 'cube';
            default:
                return 'ruler-triangle';
        }
    }
    getStandardIconStyletweak(a) {
        let type = a['annotationMode'];
        switch (type) {
            case global_1.AnnotationType.line:
                return '9px';
            default:
                return;
        }
    }
    /**
     * fired when websock indicated an annot has changed
     * @param s
     * @param mode
     */
    annotAdjust(s, mode) {
        if (this.debug) {
            console.log('inspect.component :: annotAdjust()');
        }
        var f = this.annots.find((a) => s.id == a.id);
        if (f) {
            // set all values from json
            f.set(s);
            if (mode == 'del') {
                this.annots = this.annots.filter((a) => a != f);
                this.mapService.helper.removePlottable(f);
            }
            if (mode == 'update') {
                this.mapService.updateAnnotation(f, true);
            }
        }
        else if (mode == 'add') {
            this.mapService.refreshAnnotations().subscribe();
        }
    }
    /* select and unselect tools in the inspection tools menu */
    selectTool(item) {
        if (this.debug) {
            console.log('inspect.component :: selectTool()', item);
        }
        if (this.selectedTool == item) {
            this.unselectTool();
            return;
        }
        this.selectedTool = item;
        this.setSelected(null, true, 'inspect:selectTool()');
        this.startCursorMovements();
    }
    unselectTool() {
        if (this.debug) {
            console.log('inspect.component :: unselectTool()');
        }
        this.selectedTool = false;
        this.endCursorMovements();
    }
    onLeftDownClick(movement) {
        if (this.mouseCursor) {
            // stop the cursor
            this.endCursorMovements();
        }
    }
    onMouseMove(movement) {
        if (this.mappingHelper.cached && this.mappingHelper.cached.coords) {
            this.mouseCursorCoords = this.mappingHelper.cached.coords;
        }
        /* if ( movement && movement.endPosition ) {
          let test = this.mappingHelper.pickPositionSnapToTileset(movement.endPosition);
          if ( test ) {
            this.mouseCursorCoords = test;
          }
        } */
    }
    updateCursorPosition() {
        return this.mouseCursorCoords;
    }
    startCursorMovements() {
        // console.log ( 'startCursor()');
        if (this.mouseCursor) {
            // already one, so kill it before going on
            this.endCursorMovements();
        }
        // handler for all things interaction on the map (mouse, mostly)
        this.mouseHandler = new Cesium.ScreenSpaceEventHandler(this.mapService.viewer.scene.canvas);
        // set up mouse movement handler
        this.mouseHandler.setInputAction((movement) => {
            this.onMouseMove(movement);
        }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        this.mouseCursorCoords = Cesium.Cartesian3.fromDegrees(-75.166493, 39.9060534, 10);
        // Select where to start your shape
        this.t.get('MAP.SELECT_WHERE').subscribe((s) => {
            this.mouseCursor = this.mapService.viewer.entities.add({
                name: 'cursor',
                type: 'cursor',
                position: new Cesium.CallbackProperty(() => {
                    return this.mouseCursorCoords;
                }, false),
                /* billboard : {
                  image : 'assets/images/icons/add.png',
                  // pixelOffset : new Cesium.Cartesian2(-70, -40),
                  color: Cesium.Color.WHITE.withAlpha(0.9),
                  disableDepthTestDistance:Number.POSITIVE_INFINITY,
                  width:26, height:26
                }, */
                label: {
                    text: s,
                    font: '13px sans-serif',
                    pixelOffset: new Cesium.Cartesian2(-82, -42),
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    verticalOrigin: Cesium.VerticalOrigin.TOP,
                    disableDepthTestDistance: Number.POSITIVE_INFINITY,
                },
            });
        });
        // console.log ( " @@@@@ ", this.mouseCursor, this.mouseHandler);
    }
    endCursorMovements() {
        // console.log ( 'endCursor()');
        if (this.mouseHandler) {
            this.mouseHandler.destroy();
        }
        if (this.mouseCursor) {
            this.mapService.viewer.entities.remove(this.mouseCursor);
        }
    }
    deleteAnnot(annotation) {
        if (this.debug) {
            console.log('inspect.component :: deleteAnnot()');
        }
        this.openConfirmDelete(() => this.mapService.deleteAnnotation(annotation).subscribe(), annotation.name);
    }
    filterAnnotationsByScene() {
        this.mapService.v2Maps
            .onProjectReady()
            .pipe(operators_1.map((_) => {
            // global scope
            if (!this.globalScope) {
                this.mapService.annotationValues = this.mapService.v2Maps.annotations.values;
                return;
            }
            else {
                this.mapService.annotationValues = this.mapService.v2Maps.annotations.values.filter((a) => a['sceneId'] == this.mapService.scene.id);
            }
        }))
            .subscribe();
    }
    filterClass(cn) {
        if (cn && cn.length) {
            var ors = cn.map((c) => {
                return {
                    op: '=',
                    val: c,
                    col: ['datumAsset', 'clsname'],
                };
            });
            this.mapService
                .searchAnnots({
                op: 'or',
                items: ors,
            })
                .subscribe();
        }
        else
            this.mapService.searchAnnots().subscribe();
    }
    openReport() {
        let annotations = Object.assign([], this.annots);
        let dialogRef = this.dialog.open(annotation_report_1.AnnotationReportComponent, {
            width: '80%',
            height: '90%',
            data: {
                model: annotations,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (this.debug) {
                console.log(result);
            }
        });
    }
    downloadFiles() {
        // console.log ( '111');
        this.annots.forEach((v) => {
            // console.log ( '222', v);
            if (v['showPermanent']) {
                // console.log ( '333', v);
                this.startDownloading(v);
            }
        });
    }
    startDownloading(annotation) {
        this.httpClient.get(annotation.file(annotation.name + '.json'), { responseType: 'text' }).subscribe((response) => {
            let binaryData = [];
            binaryData.push(response);
            let downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'json' }));
            downloadLink.setAttribute('download', annotation.name + '.json');
            document.body.appendChild(downloadLink);
            downloadLink.click();
            // console.log ( '444', downloadLink, annotation, annotation.name + '.json', annotation.file(annotation.name + '.json'));
        }, (error1) => {
            console.log(error1);
        });
    }
    // moved to entity.helper
    static getPin(annotation, pinColor) {
        if (!annotation)
            return;
        var icon = this.getPinIcon(annotation);
        return this.getPinImg(icon, pinColor ? pinColor : annotation['color'] || 'blue');
    }
    static getPinImg(icon, pinColor = 'red', size = 45) {
        var iconZ = pro_solid_svg_icons_1.fas[icon] || pro_solid_svg_icons_1.fas[Object.keys(pro_solid_svg_icons_1.fas).find((k) => pro_solid_svg_icons_1.fas[k].iconName == icon)];
        return ('data:image/svg+xml;base64,' +
            window['btoa']('<svg aria-hidden="true" data-prefix="fas" data-icon="tags" role="img" xmlns="http://www.w3.org/2000/svg" height="' +
                size +
                '" width="' +
                size +
                '" viewBox="0 0 640 517">' +
                '<path fill="' +
                pinColor +
                '" d="' +
                iconZ.icon[4] +
                '"></path></svg>'));
    }
    static getPinIcon(annotation) {
        return Object.keys(pro_solid_svg_icons_1.fas).find((k) => pro_solid_svg_icons_1.fas[k].iconName == (annotation['icon'] || 'map-marker-alt'));
    }
    /*
  
    decideAndMkAnnotation(value,coordinate) {
      this.createNewAnnotation(value,coordinate);
      this.router.navigate([value,'new'], {
        relativeTo: this.route,
      });
  
    }
  */
    updateAnnotationCoordinateCamera(t, checkedPosition = null) {
        let cartographic;
        let lon;
        let lat;
        if (checkedPosition) {
            cartographic = checkedPosition.currentCoord.position;
            // console.log("## coord_cam", t, cartographic, checkedPosition );
            // cartographic coordinates are always in Radians. Convert them to Degrees for more readable coords in the Annotation object
            lon = Cesium.Math.toDegrees(cartographic.longitude);
            lat = Cesium.Math.toDegrees(cartographic.latitude);
        }
        else {
            cartographic = { longitude: t.llng, latitude: t.llat, height: t.lheight };
            lon = cartographic.longitude;
            lat = cartographic.latitude;
        }
        t.camera = {
            position: {
                lat: Cesium.Math.toDegrees(this.mapService.viewer.camera.positionCartographic.latitude),
                lng: Cesium.Math.toDegrees(this.mapService.viewer.camera.positionCartographic.longitude),
                height: this.mapService.viewer.camera.positionCartographic.height,
            },
            direction: {
                heading: Cesium.Math.toDegrees(this.mapService.viewer.camera.heading),
                pitch: Cesium.Math.toDegrees(this.mapService.viewer.camera.pitch),
                roll: Cesium.Math.toDegrees(this.mapService.viewer.camera.roll),
            },
        };
        t.llat = lat;
        t.ulat = lat;
        t.llng = lon;
        t.llng = lon;
        // TODO Dont know why this is large neg sometimes non 3d maps especially)
        //t.lheight = Math.max(0, carto.height);
        //t.uheight = Math.max(0, carto.height);
        //it could be a real negative sometimes
        t.lheight = cartographic.height;
        t.uheight = cartographic.height;
    }
    createNewAnnotation(annotationMode, checkedPosition) {
        if (this.debug) {
            console.log('%c inspect.component %c createNewAnnotation()', Constants_1.Constants._purple, Constants_1.Constants._blue, annotationMode, checkedPosition);
        }
        this.translate.get(['MAP.' + annotationMode]).subscribe((p) => {
            let newAnnot = p['MAP.' + annotationMode] ? p['MAP.' + annotationMode] : 'POI';
            var t = new _4d_mapper_1.Annotation(this.fourD.V).set({
                name: newAnnot,
                project: this.mapService.currentProject,
                annotationMode: annotationMode,
            });
            if (annotationMode !== 'poi') {
                t['icon'] = 'ruler-triangle';
                t['showPermanent'] = true;
            }
            const tpe = checkedPosition.transform ? checkedPosition.transform.type_uid : {};
            let type = 'terrain'; // features['isPointCloud'] ? features['isPointCloud']
            if (tpe == 'three-d-tiles') {
                type = 'model';
            }
            t['clickedOnType'] = type;
            t['clickedOnId'] = checkedPosition.transform ? checkedPosition.transform.id : null;
            // console.log('## BLARGH',this.measureHelper.pickedModel, checkedPosition );
            // set some reference to last clicked point
            t['clickedLast'] = checkedPosition.coords;
            if (this.debug) {
                console.log('%c inspect.component %c createNewAnnotation() clicker', Constants_1.Constants._purple, Constants_1.Constants._blue, t['clickedLast']);
            }
            this.updateAnnotationCoordinateCamera(t, checkedPosition);
            this.mapService.setNewAnnotation(t);
            if (this.debug) {
                console.log('%c inspect.component %c createNewAnnotation()', Constants_1.Constants._purple, Constants_1.Constants._blue, this.route, t);
            }
            this.router.navigate([annotationMode, 'new'], {
                relativeTo: this.route,
            });
        });
    }
    showHideAnnotation(a, event = null) {
        console.log('@@@@@@@@@@@@@@@@@@@@@', a, Constants_1.Typical.dumpProps(event));
        a['showPermanent'] = event.currentTarget.checked;
        this.entityHelper.showHideEntity(a, a['showPermanent']);
        a['entity_config'] = null;
        a.saveObservable().subscribe();
        if (!a['showPermanent']) {
            this.setSelected(null, true, 'inspect:showHideAnnotation()');
        }
    }
    testEntityHelper() {
        let eid1 = 'ent-1-a0-s0';
        let eid2 = 'ent-2-a0-s1';
        let eid3 = 'ent-3-a25-s0';
        let eid4 = 'ent-4-a25-s1';
        let temporary = 0;
        let correct = 25;
        let faulty = 39;
        this.entityHelper.setEntityId(temporary, 0, eid1);
        console.log('TEST 1', eid1, this.entityHelper.getEntityId(temporary, 0));
        this.entityHelper.setEntityId(temporary, 1, eid2);
        console.log('TEST 2', eid2, this.entityHelper.getEntityId(temporary, 1));
        this.entityHelper.setEntityId(correct, 0, eid3);
        console.log('TEST 3', eid3, this.entityHelper.getEntityId(correct, 0));
        this.entityHelper.setEntityId(correct, 1, eid4);
        console.log('TEST 4', eid4, this.entityHelper.getEntityId(correct, 1));
        console.log('TEST 5', null, this.entityHelper.getEntityId(faulty, 0));
        console.log('TEST 6', null, this.entityHelper.getEntityId(faulty, 1));
    }
}
exports.InspectionComponent = InspectionComponent;
